export default {
  state: {
    courses: [],
    course: {}
  },
  getters: {
    courses(state) {
      return state.courses
    },
    course(state) {
      return state.course
    }
  },
  mutations: {
    updateCourses(state, courses) {
      state.courses = courses
    },
    setCourse(state, course) {
      state.course = course
    },
  },
  actions: {
    async getCourses({ dispatch, commit }, { idUser, id }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourses",
          pathVariable: null,
          data: { idUser, id }
        });
        if (objectResponse.bodyJson) {
          commit("updateCourses", objectResponse.bodyJson)
        }        
      } catch (e) { }
    },
  }

}
